module.exports = __webpack_public_path__ + "img/behaviour-2.c2af55a4.gif";